import { useSelector } from 'react-redux'
import { IStore } from '../interfaces/Store'
import {
  getInvalidStep,
  getLastVisitedStep,
  getRevisitSteps,
  isJourneyRevisit,
  isJourneySigned,
  isPatrimonyStepAvailable,
} from '../services/utils'
import { IBreadCrumb } from '../interfaces/Breadcrumb'

function useStepHook() {
  const { breadcrumb, step } = useSelector(
    (state: IStore) => state.breadcrumbReducer
  )
  const journeyStatus = useSelector(
    (state: IStore) => state.folderReducer.folder.journeyStatus
  )

  const isMediumOrLowRisk = useSelector(
    (store: IStore) => store.folderReducer.isMediumOrLowRisk
  )

  const isLastStep = () => {
    const navigation = getRevisitSteps(breadcrumb)
    if (isJourneyRevisit(journeyStatus) && navigation.length > 0) {
      return breadcrumb[step].titre === navigation[navigation.length - 1].titre
    }
    const invalidatedStep = getInvalidStep(breadcrumb, step)

    if (isJourneySigned(journeyStatus) && invalidatedStep === -1) {
      return true
    }

    if (invalidatedStep !== -1 && step !== 5) {
      return false
    }

    return step === 5
  }

  const getNextStep = (breadcrumbs: IBreadCrumb[] = breadcrumb) => {
    const invalidatedStep = getInvalidStep(breadcrumbs, step, isMediumOrLowRisk)
    if (invalidatedStep !== -1) {
      return invalidatedStep
    }
    const lastVisitedStep = getLastVisitedStep(breadcrumbs, isMediumOrLowRisk)
    if (lastVisitedStep !== -1 && lastVisitedStep !== step) {
      return lastVisitedStep
    }
    if (breadcrumbs.every((item) => item.visited)) {
      return step
    }
    if (isLastStep()) {
      return step
    }

    return isPatrimonyStepAvailable(isMediumOrLowRisk, step + 1)
      ? step + 1
      : step + 2
  }

  return { getNextStep, isLastStep }
}

export default useStepHook
